class ProductMedias extends HTMLElement {
  constructor() {
    super();
    this.swiperInit();
    this.variants_color = document.querySelectorAll(
      'variant-radios input[name="color"]'
    );
    //console.log(this.variants_color);
    if (this.variants_color) {
      this.updateMedia();
      this.variants_color.forEach((variant) => {
        variant.addEventListener("change", this.updateMedia.bind(this));
      });
    }
    document
      .querySelectorAll(".modal-product-medias__close")
      .forEach((button) => {
        button.addEventListener("click", this.closeModal.bind(this));
      });
    document
      .querySelectorAll("product-medias .product__media-toggle")
      .forEach((button) => {
        button.addEventListener("click", this.openModal.bind(this));
      });
    document
      .querySelector(".product-medias__header--close-zoom")
      .addEventListener("click", this.closeModal.bind(this));

    this.zoomObject = null;
    this.enableTouch = true;
  }

  swiperInit() {
    this.swiper = new Swiper(".product-medias__thumbnail--main", {
      slidesPerView: 4,
      spaceBetween: 15,
      direction: "horizontal",
      allowTouchMove: false,
      loopPreventsSlide: false,
      edgeSwipeDetection: "prevent",
      preventClicks: true,
      preventClicksPropagation: true,
      touchMoveStopPropagation: false,
      a11y: false,
      speed: 400,
      threshold: 15,
      touchStartForcePreventDefault: false,
      navigation: {
        nextEl: ".products-thumb-v2__next--thumb ",
        prevEl: ".products-thumb-v2__prev--thumb ",
      },
      breakpoints: {
        1140: {
          allowTouchMove: false,
          spaceBetween: 30,
          slidesPerView: 4,
          direction: "vertical",
        },
      },
    });

    this.swiper2 = new Swiper(".product-medias__main--main", {
      allowTouchMove: true,
      threshold: 10,
      thumbs: {
        swiper: this.swiper,
        autoScrollOffset: 0,
        thumbsContainerClass: "thumbs-container",
      },
      noSwipingClass: "swiper-no-swiping",
      breakpoints: {
        1140: {
          allowTouchMove: false,
        },
      },
    });

    this.swiper2.on("slideChange", this.updateSlide.bind(this));
  }

  updateMedia() {
    //console.log(this.currentVariant);

    this.current_color = document
      .querySelector('[name="color"]:checked')
      .getAttribute("value")
      .toLowerCase();

    this.showVariantsMedias();
  }

  showVariantsMedias() {
    var variants_img = document.querySelectorAll("[variant-img]");

    variants_img.forEach((img) => {
      //console.log(img);
      img.classList.remove("swiper-slide");
      img.classList.remove("swiper-slide-active");
      img.classList.remove("swiper-slide-prev");
      img.setAttribute("hidden", "hidden");
    });

    var variants_img_color = document.querySelectorAll(
      '[variant-img="' + this.current_color + '"]'
    );

    variants_img_color.forEach((img) => {
      //console.log(img);
      img.classList.add("swiper-slide");
      img.removeAttribute("hidden", "hidden");
    });

    this.swiper.update();
    this.swiper2.update();
  }

  openModal(e) {
    if (!document.querySelector(".template-giftcard")) {
      document
        .querySelector('[name="viewport"]')
        .setAttribute("content", "width=device-width, user-scalable=no");
      document.querySelector("body").classList.add("overflow-hidden");
      var image_index = e.target
        .closest(".product-medias__item")
        .getAttribute("data-image-index");
      document
        .querySelector(".product-medias")
        .classList.add("product-medias--zoom");
      this.createZoom();
      document.addEventListener("gesturestart", function (e) {
        e.preventDefault();
        // special hack to prevent zoom-to-tabs gesture in safari
        document.body.style.zoom = 0.99;
      });

      document.addEventListener("gesturechange", function (e) {
        e.preventDefault();
        // special hack to prevent zoom-to-tabs gesture in safari
        document.body.style.zoom = 0.99;
      });

      document.addEventListener("gestureend", function (e) {
        e.preventDefault();
        // special hack to prevent zoom-to-tabs gesture in safari
        document.body.style.zoom = 0.99;
      });
    }
  }

  closeModal() {
    document
      .querySelector('[name="viewport"]')
      .setAttribute("content", "width=device-width,initial-scale=1");
    document.querySelector("body").classList.remove("overflow-hidden");
    document
      .querySelector(".product-medias")
      .classList.remove("product-medias--zoom");
    this.zoomObject.destroy();
    this.zoomObject = null;
    document.removeEventListener("gesturestart", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.removeEventListener("gesturechange", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });

    document.removeEventListener("gestureend", function (e) {
      e.preventDefault();
      // special hack to prevent zoom-to-tabs gesture in safari
      document.body.style.zoom = 0.99;
    });
  }

  updateSlide() {
    //console.log(" UPDATE SLIDE ");

    if (
      document
        .querySelector("product-medias")
        .classList.contains("product-medias--zoom")
    ) {
      setTimeout(
        function () {
          if (this.zoomObject != null) {
            this.zoomObject.destroy();
            this.zoomObject = null;
          }

          this.createZoom();
        }.bind(this),
        600
      );
    }
  }

  createZoom() {
    var slide = document.querySelector(
      ".product-medias__main .swiper-slide-active .product__media img"
    );

    var imageElement = slide;

    //console.log(imageElement.naturalWidth, imageElement.naturalHeight);

    this.zoomObject = WZoom.create(slide, {
      type: "html",
      width: imageElement.width,
      height: imageElement.height,
      maxScale: 3,
      minScale: 1,
      dragScrollable: true,
      speed: 4,
      zoomOnClick: true,
      disableWheelZoom: false,
      rescale: function () {
        //console.log(slide.getAttribute('style'));
        var current_scale = parseFloat(
          slide.getAttribute("style").split("scale(")[1].split(")")[0]
        );
        if (current_scale > 1.2) {
          this.enableTouch = false;
        } else {
          this.enableTouch = true;
        }
        if (!this.enableTouch) {
          document
            .querySelector(".product-medias__main--main")
            .classList.add("swiper-no-swiping");
        } else {
          document
            .querySelector(".product-medias__main--main")
            .classList.remove("swiper-no-swiping");
          return false;
        }
      }.bind(this),
      dragScrollableOptions: {
        onGrab: function () {
          slide.style.cursor = "grabbing";
        },
        onDrop: function () {
          slide.style.cursor = "grab";
        },
      },
    });

    this.zoomObject.zoomUp();
  }
}

customElements.define("product-medias", ProductMedias);
